module.exports = __webpack_public_path__ + "img/group-new.dc5eb437.png";